<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX188cbBy1oiZItvREy5MhQVTjUdY+4kM3As=","cpf":"U2FsdGVkX1/zOPEp4xGakK5q66iDY+tZdM79B+DNu78="},{"num_cand":"U2FsdGVkX1+zZtf4EG6QLzxSvHhPMkFtpL4Q/KgzNEQ=","cpf":"U2FsdGVkX18cGDxpKGZ25jGk2OfHVtJkxQl/cR9b07k="},{"num_cand":"U2FsdGVkX19Lqn+MzsCrC7koZyNKfiKnRDTy00q4DNM=","cpf":"U2FsdGVkX199eCtA2TXCTM+D7PJPvA3+dXiszRzzQMY="},{"num_cand":"U2FsdGVkX19hTHavtKaj2EO6Vm2F4OJAON8KfGlcK5o=","cpf":"U2FsdGVkX1/vDcBErBGsjYJdEzYkyj6ZcAs3rK2fa9c="},{"num_cand":"U2FsdGVkX198UamR8ufeFdN8v6luZ+ErO5TyUb/rlSk=","cpf":"U2FsdGVkX19p3jCeziSEzBhMpCV475cgC5HifKSRCFo="},{"num_cand":"U2FsdGVkX18HYdyYhNz3Q2ILd4KPZnWuCAxYCvrsmzA=","cpf":"U2FsdGVkX1+sNiAt1jxCNB8OaFodg6uTNur9GaBxR9o="},{"num_cand":"U2FsdGVkX19V2dt9OjivuODwTmUsJ4KFlY49qMHnJ/U=","cpf":"U2FsdGVkX19FjHwPwppigVxKTywSJxpIgauBv9hsMs4="},{"num_cand":"U2FsdGVkX192zsda3KMJ4P6OIYF4rVjei4ucWnQ0Flc=","cpf":"U2FsdGVkX1+goHeJ1FEygQP2amkEINQZx2IGdYADMS4="},{"num_cand":"U2FsdGVkX1/YLSG1pimO8Khg4UfYDZvbrgDX0Ak9G/c=","cpf":"U2FsdGVkX1/c+DwmNh8VK6H5ClTcrdJFUwpyQK2BA0Y="},{"num_cand":"U2FsdGVkX1+oDi+5zU7g0KFf5QF7ZY6wnoSwGjcmFE4=","cpf":"U2FsdGVkX19J/lacj5Zkvx+tlD2xmDEhNQ5CGTl8UX4="},{"num_cand":"U2FsdGVkX18x+iTZ/Q7675lcP7xuFoh5IRApo/hKzng=","cpf":"U2FsdGVkX195p2lxL9ztr2XAwyL6uhE2/MqhucFmSBo="},{"num_cand":"U2FsdGVkX19AdoscR5V04pgZiSspiLhYQecS5BFNb3Q=","cpf":"U2FsdGVkX18RNBh+u9SMgV1Y7bGJmmic58AyCJho33U="},{"num_cand":"U2FsdGVkX19z98uci0H23lRdWUD7EuWonpV6iRCf1lg=","cpf":"U2FsdGVkX1+Rpq81EsVH6KF9BjpomJpZqvivcyjh7Eo="},{"num_cand":"U2FsdGVkX19z+wiFZyRW8Pk9+pNQlGNh8b76M9LbEMQ=","cpf":"U2FsdGVkX19G45+JM7XpvJM5miGn2gRwep2iPrZvQMg="},{"num_cand":"U2FsdGVkX18H4yYsE9t1JnCzYQhDTUAUxSioaC/iJvU=","cpf":"U2FsdGVkX1/oAjZD312JEOWHX1+Mv2X6oyPpZZ5ts3M="},{"num_cand":"U2FsdGVkX18lQAFM5l048cUTWTTL1eFqBaegVasP6AE=","cpf":"U2FsdGVkX1+Fnae1DatKWIEsr/2qX2IF29vhz8spdSo="},{"num_cand":"U2FsdGVkX19h9iWBBNx2FAHfTvaoJxOvVwdAca972Ls=","cpf":"U2FsdGVkX1/fwBPo79iruoMXxzeTiLnTGwHtvw9+bfQ="},{"num_cand":"U2FsdGVkX199m3Dy6ActHu9YJydcEUd9FA8tb3tR13k=","cpf":"U2FsdGVkX19WI76lyEW4MgufjpXBqiVui74qyO1UhnY="},{"num_cand":"U2FsdGVkX18q2Ox0R5QpJNdXJE+xXDImWtVK9VGeiqI=","cpf":"U2FsdGVkX1+gMhDHXwqtZNoVqrp1vgtODAhtyIDyO/U="},{"num_cand":"U2FsdGVkX19KcMseajqh3bDgg8eAVX1DgYRaUgqovBQ=","cpf":"U2FsdGVkX193jl85tUONLL3JejdWgf1vDXRwYcyKqvk="},{"num_cand":"U2FsdGVkX18OaLnauPosa/mifsk1yDTEBBsFUDFg0tg=","cpf":"U2FsdGVkX1+zuAqJqi98ajxBDMrL20/E+8uUU3C05R8="},{"num_cand":"U2FsdGVkX19/hAd6nlW326s9KbRlRLYBX6nbj110TLs=","cpf":"U2FsdGVkX1+IF0IpbhM9B9EUccBW8YgbJt297l73moE="},{"num_cand":"U2FsdGVkX18A+LyH3IKMKWFfdJ8wjZjZTxft4Z9Wwrk=","cpf":"U2FsdGVkX1/6Bsohzh8TXqCltzzbocVaaduWZ58O/24="},{"num_cand":"U2FsdGVkX19OfWHvJ8uBWXWge0agmDTRpcYLBsg1Qqg=","cpf":"U2FsdGVkX18uyVWxG2xUiP0QBOzlzq/vdyyUumBI6vw="},{"num_cand":"U2FsdGVkX1923cjfme5Yjh7n+NSZ+stuObUXZ9WfAz8=","cpf":"U2FsdGVkX18IShfRlUay9V+7GFgO7xcAANM4fKWORxQ="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2209/res_tit/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
